module.exports = __webpack_public_path__ + "img/8.7a996bab.png";